import * as React from "react";
import Box from "@mui/material/Box";
import { useState, useEffect, useRef } from "react";
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { Grid, Paper } from "@mui/material";
import { TreeView, TreeItem } from "@mui/x-tree-view";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import * as GD from "./GeneralDescription"
import Bienvenido from "./Bienvenido.js"
import * as Concept from "./Conceptos.js"
import {Project} from "./Project.js"
import * as VM from "./Vm.js"
import * as VM_actions from "./Vm_actions.js"
import * as NET from "./Network.js"
import * as LBaaS from "./LBaaS.js"
import * as VPN from "./VPN.js"
import * as COO from "./CloudOnOff.js"

const darkTheme = createTheme({
	palette: {
		mode: 'light',
		primary: {
			main: '#000000',
		},
	},
});

export const General = () => {

	const [ selectedSection, setSelectedSection ] = useState(Bienvenido)

	const ref = useRef(null);

	const scrollToBottom = () => {
		const firstChildElement = ref.current?.lastElementChild;
		firstChildElement?.scrollIntoView({ behavior: 'smooth' });
	};

	useEffect(() => {
		scrollToBottom();
	}, [selectedSection]);

	return (
	<ThemeProvider theme={darkTheme}>
		<Box sx={{ flexGrow: 1, marginLeft:"10px", height:"100%"}}>
			<Grid container spacing={2} marginTop="60px" xs={12} sx={{height:"100%"}}>
				<Grid item xs={3} sx={{height:"100%"}}>
					<Paper sx={{height:"100%"}}>
						<SelectTree selected={setSelectedSection}/>
					</Paper>
				</Grid>
				<Grid item xs={9}>
					<Paper
						ref={ref}
						sx={{
							display: "flex",
							justifyContent: "center",
							alignItems: "center"
						}}
						style={{maxWidth:"1000px"}}
					>
						{selectedSection}
					</Paper>
				</Grid>
			</Grid>
		</Box>
	</ThemeProvider>
	)

}

const SelectTree = (props) => {

	const { selected } = props

	return (
	<TreeView
		aria-label="Tree view help"
		defaultCollapseIcon={<ExpandMoreIcon />}
		defaultExpandIcon={<ChevronRightIcon />}
		sx={{ height:"87vh", flexGrow: 1, maxWidth: 400, overflowY: 'auto', overflowX:"hidden",}}
	>
		<TreeItem nodeId="1" label="Introducción" onClick={()=>selected(Bienvenido)} sx={{ marginTop:"5px" }}/>
		<TreeItem nodeId="2" label="Conceptos" onClick={()=>selected(Concept.Conceptos)} sx={{ marginTop:"5px" }}>
			<TreeItem nodeId="20" label="Nube" onClick={()=>selected(Concept.ConCloud)} sx={{ marginTop:"5px" }}/>
			{/*<TreeItem nodeId="21" label="Elementos" onClick={()=>selected(Concept.ConElement)} sx={{ marginTop:"5px" }}/>*/}
			<TreeItem nodeId="22" label="Proyectos" onClick={()=>selected(Concept.ConProject)} sx={{ marginTop:"5px" }}/>
			<TreeItem
				nodeId="23"
				label="Networking"
				onClick={()=>selected(Concept.ConNetworking)} sx={{ marginTop:"5px" }}
			>
				<TreeItem
					nodeId="231" label="Redes"
					onClick={()=>selected(Concept.ConNetworks)}
					sx={{ marginTop:"5px" }}
				/>
				<TreeItem
					nodeId="232" label="Routers"
					onClick={()=>selected(Concept.ConRouters)}
					sx={{ marginTop:"5px" }}
				/>
				<TreeItem
					nodeId="233" label="Grupos de Seguridad"
					onClick={()=>selected(Concept.ConSG)}
					sx={{ marginTop:"5px" }}
				/>
				<TreeItem
					nodeId="234" label="IP públicas"
					onClick={()=>selected(Concept.ConPublicIP)}
					sx={{ marginTop:"5px" }}
				/>
				<TreeItem
					nodeId="235" label="VPN"
					onClick={()=>selected(Concept.ConVPN)}
					sx={{ marginTop:"5px" }}
				/>
				<TreeItem
					nodeId="236" label="Balanceadores"
					onClick={()=>selected(Concept.ConLBaaS)}
					sx={{ marginTop:"5px" }}
				>
					<TreeItem
						nodeId="2351" label="Miembros"
						onClick={()=>selected(Concept.ConLBaaSMember)}
						sx={{ marginTop:"5px" }}
					/>
					<TreeItem
						nodeId="2352" label="Grupos(Pools)"
						onClick={()=>selected(Concept.ConLBaaSPool)}
						sx={{ marginTop:"5px" }}
					/>
					<TreeItem
						nodeId="2353" label="Puntos de Acceso(Listeners)"
						onClick={()=>selected(Concept.ConLBaaSListener)}
						sx={{ marginTop:"5px" }}
					/>
				 	<TreeItem nodeId="184" label="Políticas capa 7"
						onClick={()=>selected(Concept.ConLBaaSL7)}
						sx={{ marginTop:"5px" }}
					/>

				</TreeItem>
			</TreeItem>
		</TreeItem>
		
		<TreeItem nodeId="3" label="Panel de Gestión" onClick={()=>selected(GD.PanelWeb)} sx={{ marginTop:"5px" }}>
			<TreeItem nodeId="31" label="Detalle" onClick={()=>selected(GD.DetailPanel)}/>
			<TreeItem nodeId="32" label="Gestion" onClick={()=>selected(GD.GestionPanel)}>
				<TreeItem nodeId="5" label="Usuarios" onClick={()=>selected(GD.GestionUsers)}>
					<TreeItem nodeId="6" label="Gestión de Usuarios" onClick={()=>selected(GD.GestionUsers_Users)}/>
					<TreeItem nodeId="7" label="Gestión de Grupos" onClick={()=>selected(GD.GestionUsers_Groups)}/>
				 </TreeItem>
				 <TreeItem nodeId="8" label="Proyectos" onClick={()=>selected(Project)}/>
				 <TreeItem nodeId="9" label="Permisos" onClick={()=>selected(GD.GestionPermissions)}/>
			</TreeItem>
			<TreeItem nodeId="10" label="Cómputo" onClick={()=>selected(VM.ComputoPanel)}>
				 {/*<TreeItem nodeId="11" label="SVP" onClick={()=>selected(VM.ComputoSVP)}/>*/}
				 <TreeItem nodeId="12" label="Máquina Virtual" onClick={()=>selected(VM.ComputoMV)}>
				 	<TreeItem nodeId="121" label="Acciones" onClick={()=>selected(VM_actions.ComputoAcciones)}/>
				</TreeItem>
			</TreeItem>
			<TreeItem nodeId="13" label="Network" onClick={()=>selected(NET.NetworkPanel)}>
				 <TreeItem nodeId="14" label="Redes" onClick={()=>selected(NET.NetworkNet)}/>
				 <TreeItem nodeId="15" label="Grupos de Seguridad" onClick={()=>selected(NET.NetworkGroups)}/>
				 <TreeItem nodeId="16" label="Routers" onClick={()=>selected(NET.NetworkRouters)}/>
				 <TreeItem nodeId="17" label="IP Pública" onClick={()=>selected(NET.NetworkIPs)}/>
				 <TreeItem nodeId="18" label="Balanceador" onClick={()=>selected(LBaaS.LBIntro)}>
				 	<TreeItem nodeId="181" label="Acciones generales" onClick={()=>selected(LBaaS.LBActions)}/>
				 	<TreeItem nodeId="182" label="Punto de acceso" onClick={()=>selected(LBaaS.LBListenerActions)}/>
				 	<TreeItem nodeId="183" label="Grupos" onClick={()=>selected(LBaaS.LBPoolActions)}/>
				</TreeItem>
				<TreeItem nodeId="19" label="VPN" onClick={()=>selected(VPN.VPNIntro)}>
					<TreeItem nodeId="191" label="Acciones" onClick={()=>selected(VPN.VPNActions)}/>
				</TreeItem>
			</TreeItem>
			<TreeItem nodeId="18" label="Almacenamiento" onClick={()=>selected(GD.StoragePanel)}>
				<TreeItem nodeId="19" label="Volúmenes" onClick={()=>selected(GD.StorageVolumenes)}/>
			</TreeItem>
		</TreeItem>
		<TreeItem nodeId="4" label="Tareas" onClick={()=>selected(COO.Acciones)} sx={{ marginTop:"5px" }}>
			<TreeItem nodeId="40" label="Conectar y Desconectar la Nube" onClick={()=>selected(COO.CloudOnOff)} sx={{ marginTop:"5px" }}/>
			<TreeItem nodeId="41" label="Crear VPN" onClick={()=>selected(VPN.VPNmake)} sx={{ marginTop:"5px" }}/>
		</TreeItem>
	</TreeView>
	)
}

